import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {ThemeService} from "@services";
import {Subscription} from "rxjs";
import {RouterLink} from "@angular/router";

/**
 * Logo Component displays Logo and
 * sets custom redirect URL
 *
 * ```html
 * <sim-logo>
 *    [disableLink]="false"
 *    [logoUrl]="url_here"
 *    [inverted]="false"
 * </sim-logo> ```
 * <example-url>../assets/examples/example_component_logo.PNG</example-url>
 */
@Component({
	selector: "sim-logo",
	templateUrl: "./logo.component.html",
	styleUrls: ["./logo.component.scss"],
	imports: [RouterLink],
	standalone: true,
})
export class LogoComponent implements OnInit, OnDestroy {
	/** Redirect Link **/
	redirectLink = environment.routes.eventDashboard;
	/** logoUrl Input **/
	@Input()
	logoUrl: string;
	/** disable Link input **/
	@Input()
	disableLink = false;
	/** inverted Input **/
	@Input()
	inverted = false;
	/** Default logoUrl Default **/
	private logoUrlDefault = "/Content/media/logo_simstationW.png";
	private logoUrlDefaultLight = "/Content/media/Logo_RGB_WebWord_noClaimTeal.svg";
	/** Default logoUrl Inverted **/
	private logoUrlInverted = "/Content/media/Logo_RGB_whiteFonts_withoutClaim.svg";
	private logoUrlInvertedLight = "/Content/media/Logo_RGB_WebWord_noClaimTeal.svg";
	logoUrlSmall = "/Content/media/favicon.svg";
	private themeSubject: Subscription;

	/**
	 * Logo Component Constructor
	 */
	constructor(private themeService: ThemeService) {
		if (this.themeService.currentTheme === "simstationLight-theme") {
			this.logoUrl = this.logoUrlInvertedLight;
		} else {
			this.logoUrl = this.logoUrlInverted;
		}

		this.themeSubject = this.themeService.themeSubject.subscribe((data: string) => {
			if (data === "simstationLight-theme") {
				this.logoUrl = this.logoUrlInvertedLight;
			} else {
				this.logoUrl = this.logoUrlInverted;
			}
		});
	}

	/**
	 * Before Rendering
	 */
	ngOnInit() {
		if (!this.logoUrl) {
			if (!this.inverted) {
				this.logoUrl = this.logoUrlDefault;
			} else {
				this.logoUrl = this.logoUrlInverted;
			}
		}

		// TODO: Evaluate redirect url from path
		if (!this.redirectLink.startsWith("/")) {
			this.redirectLink = "/" + this.redirectLink;
		}
	}

	ngOnDestroy(): void {
		this.themeSubject.unsubscribe();
	}
}
